var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscrepancyCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 0V1.33333H8.66667V0H10V1.33333H12.6667C13.0349 1.33333 13.3333 1.63181 13.3333 2V12.6667C13.3333 13.0349 13.0349 13.3333 12.6667 13.3333H0.666667C0.29848 13.3333 0 13.0349 0 12.6667V2C0 1.63181 0.29848 1.33333 0.666667 1.33333H3.33333V0H4.66667ZM12 6.66667H1.33333V12H12V6.66667ZM6 8V10.6667H2.66667V8H6ZM3.33333 2.66667H1.33333V5.33333H12V2.66667H10V4H8.66667V2.66667H4.66667V4H3.33333V2.66667Z",
    fill: "#416EB2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscrepancyCalendarIcon);
export default __webpack_public_path__ + "static/media/discrepancy-calendar-icon.a468aa67d53da3bb7b65440f4260f1cc.svg";
export { ForwardRef as ReactComponent };